/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {combineReducers} from 'redux';

import {USER_LOGOUT} from 'store/action/user';

import {ReduxDispatchActions} from 'interfaces';

import websocket, {IWebsocketState} from './websocket';
import channels, {IChannelsState} from './channels';
import channelDetails, {IChannelDetailsState} from './channel-details';
import channelStreams, {IChannelStreamsState} from './channel-streams';
import messages, {IMessagesState} from './messages';
import channelsPublishing, {IChannelsPublishingState} from './channels-publishing';
import publishingHistory, {IPublishingHistoryState} from './publishing-history';
import forkingHistory, {IForkingHistoryState} from './forking-history';
import user, {IUserState} from './user';
import concurrents, {IConcurrentsState} from './concurrents';
import rooms, {IRoomsState} from 'store/reducers/rooms';
import roomDetails, {IRoomDetailsState} from 'store/reducers/room-details';
import roomMembers, {IRoomMembersState} from 'store/reducers/room-members';
import roomsPublishing, {IRoomsPublishingState} from './rooms-publishing';
import ingest, {IIngestState} from './ingest';
import screens, {IScreensState} from './screens';
import qos, {IQosState} from './qos';
import playlist, {IPlaylistState} from './playlist';
import usageSummary, {IUsageSummaryState} from './usage-summary';
import currentActivity, {ICurrentActivityState} from './current-activity';
import usageStatistics, {IUsageStatisticsState} from './usage-statistics';
import timeToFirstFrame, {ITimeToFirstFrameState} from './time-to-first-frame';
import preferredTimeFormat, {IPreferredTimeFormatState} from './preferred-time-format';

export interface IAppStore {
  channels: IChannelsState;
  channelDetails: IChannelDetailsState;
  channelStreams: IChannelStreamsState;
  messages: IMessagesState;
  channelsPublishing: IChannelsPublishingState;
  concurrents: IConcurrentsState;
  forkingHistory: IForkingHistoryState;
  ingest: IIngestState;
  publishingHistory: IPublishingHistoryState;
  rooms: IRoomsState;
  roomDetails: IRoomDetailsState;
  roomMembers: IRoomMembersState;
  roomsPublishing: IRoomsPublishingState;
  screens: IScreensState;
  user: IUserState;
  websocket: IWebsocketState;
  qos: IQosState;
  playlist: IPlaylistState;
  usageSummary: IUsageSummaryState;
  currentActivity: ICurrentActivityState;
  usageStatistics: IUsageStatisticsState;
  timeToFirstFrame: ITimeToFirstFrameState;
  preferredTimeFormat: IPreferredTimeFormatState;
}

const rootReducer = combineReducers<IAppStore>({
  channels,
  channelDetails,
  channelStreams,
  messages,
  channelsPublishing,
  concurrents,
  forkingHistory,
  ingest,
  publishingHistory,
  rooms,
  roomDetails,
  roomMembers,
  roomsPublishing,
  screens,
  user,
  websocket,
  qos,
  playlist,
  usageSummary,
  currentActivity,
  usageStatistics,
  timeToFirstFrame,
  preferredTimeFormat
});

export default (state: IAppStore, action: ReduxDispatchActions): IAppStore => {
  if (action.type === USER_LOGOUT) {
    state = undefined;
  }

  return rootReducer(state, action);
};